import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 64px;
  width: 100%;
  @media (max-width: ${({ theme }) => theme.v3.breakpoints.md}) {
    flex-direction: column;
    gap: 32px;
  }
`;

export const Title = styled.h2`
  ${({ theme }) => css`
    font-family: ${theme.v3.font.family.brand};
    font-size: ${theme.v3.font.sizes['1xhuge']};
    font-weight: ${theme.v3.font.weights.medium};
    color: ${theme.v3.colors.neutral[5]};
    line-height: ${theme.v3.font.lineHeight.spacious};
    margin: 0;
    width: 100%;
    @media (max-width: ${theme.v3.breakpoints.md}) {
      font-size: ${theme.v3.font.sizes['1xlarge']};
    }
  `}
`;

export const ItemList = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.v3.spacing.xxxs};
  width: 100%;
`;

export const Item = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    background: #FAFAFA;
    border-radius: ${theme.v3.border.radius.xl};
    padding: ${theme.v3.spacing.xxs};
    cursor: pointer;
    width: 100%;
  `}
`;

export const QuestionRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

export const Question = styled.span`
  ${({ theme }) => css`
    font-family: ${theme.v3.font.family.brand};
    font-size: ${theme.v3.font.sizes.medium};
    font-weight: ${theme.v3.font.weights.medium};
    color: ${theme.v3.colors.neutral[5]};
  `}
`;

export const ToggleIcon = styled.span`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    width: ${theme.v3.icon.size.md};
    height: ${theme.v3.icon.size.md};
    font-size: 20px;
    color: ${theme.v3.colors.neutral[50]};
    font-family: ${theme.v3.font.family.brand};
    flex-shrink: 0;
    user-select: none;
  `}
`;

export const Answer = styled.div`
  ${({ theme }) => css`
    font-family: ${theme.v3.font.family.brand};
    font-size: ${theme.v3.font.sizes.medium};
    font-weight: ${theme.v3.font.weights.regular};
    color: #535862;
    line-height: ${theme.v3.font.lineHeight.comfortable};
    margin-top: ${theme.v3.spacing.quarck};
  `}
`;
